import { BaseApi } from '@/main/baseApi';

import { DMS_MODULE, NAME } from './constants';

class DelbaPpProvider extends BaseApi {
	async updateRows(ppId: number, rows: { ZaznamId: number, CasJdnPoc: number, PracovnikId: number }[]) {
		return this.update(`/${this.area}/${this.controller}/UpdateRows?ppId=${ppId}`, rows);
	}
}

export const apiProvider = new DelbaPpProvider(DMS_MODULE, NAME);
